<template>
  <div id="home">

    <div class="content">
      <div class="title">
        Action Items
      </div>
      <div class="center">
        <el-select style="width: 240px;margin-right: 10px;" v-model="dismiss" placeholder="Dismiss" @change="getDatas(1)">
          <el-option v-for="item in dismiss_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-input placeholder="Search here" v-model="search" class="input-with-select" style="width: 300px;" clearable>
          <el-button slot="append" icon="el-icon-search" @click="search_list"></el-button>
        </el-input>
      </div>
      <el-table
        v-loading="table_loading"
        :data="tableData"
        :header-cell-style="{ fontSize: '14px', backgroundColor: '#F8F9FA',color:'#4A5468',fontWeight:'normal'}"
        :cell-style="{ fontSize: '14px'}"
        @sort-change="order_change"
        :default-sort = "{prop: 'date', order: 'descending'}"
        style="width: 100%;">

        <el-table-column
          align="left"
          min-width="300"
          label="Content">
          <template slot-scope="scope">
            <div @click="show_edit(scope.row.call_sid)" :style="!scope.row.show_display?'text-decoration: line-through;':''" style="display: -webkit-box;-webkit-line-clamp: 10;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;cursor: pointer;">
              {{scope.row.action_items}}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          min-width="180"
          sortable="custom"
          label="Due Date">
          <template slot-scope="scope">
            <div :style="!scope.row.show_display?'text-decoration: line-through;':''">
                {{moment(scope.row.due_datetime).format('MMM DD , YYYY')}}
            </div>
          </template>
        </el-table-column>


        <el-table-column
          align="center"
          min-width="120"
          label="Dismiss">
          <template slot-scope="scope">
            <i class="el-icon-success" style="font-size: 20px;color: #5856D6;cursor: pointer;" v-if="!scope.row.show_display" @click="dismiss_change(scope.$index)"></i>
            <i class="el-icon-circle-check" style="font-size: 20px;color: #bdbdbd;cursor: pointer;" v-if="scope.row.show_display" @click="dismiss_change(scope.$index)"></i>
          </template>
        </el-table-column>

      </el-table>
      <div class="pager">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :page-size="page_size"
          :total="totalRows">
        </el-pagination>
      </div>
    </div>
    <show ref="viewForm"></show>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { getActionApi,putActionApi } from '@/network/manageApi';
  import moment from 'moment/moment';
  import Show from './callInquiries/show'
  export default {
    name: 'ActionItemList',
    components: {
      Show
    },
    data() {
      return {
        totalRows: 0,
        current_page: 1,
        page_size: 20,
        search: "",
        tableData: [],
        table_loading: false,
        sort: 'BY_TODAY',
        dismiss: "ALL",
        dismiss_data: [{value: 'ALL', label: 'ALL'}, {value: 'COMPLETED', label: 'COMPLETED'}, {value: 'INCOMPLETED', label: 'INCOMPLETED'}],
      }
    },
    computed: {
    },
    mounted() {

    },
    created(){
      this.getDatas(1)
    },
    methods:{
      show_edit(id) {
        this.$refs.viewForm.init(id)
      },
      dismiss_change(index) {
        this.tableData[index].show_display = !this.tableData[index].show_display
        let param = {show_item: this.tableData[index].show_display}
        putActionApi("/inquiry/call-inquiry/action-items/" + this.tableData[index].twilio_call_analysis_action_items_uuid + "/status-change", param);
      },
      search_list() {
        this.getDatas(1)
      },
      order_change(column, prop, order ) {
        if(column.order == "ascending") {
          this.sort = "ASC"
        } else if(column.order == "descending"){
          this.sort = "DESC"
        } else {
          this.sort = "BY_TODAY"
        }
        this.getDatas()
      },
      moment,
      getDatas(initSize) {
        if(initSize != null) {
          this.current_page = initSize
        }
        this.table_loading = true
        let param = {sort_by_due_date: this.sort}
        if(this.search != null && this.search != undefined) {
          param.search = this.search
        }
        if(this.dismiss) {
          param.dismiss = this.dismiss
        } else {
          param.dismiss = "ALL"
        }
        getActionApi("/inquiry/call-inquiry/action-items?size=" + this.page_size + "&page=" + this.current_page,param).then((res) => {
          this.tableData = res.data
          this.totalRows = res.page.totalElements
        }).catch((err) => {
        }).finally((res) => {
          this.table_loading = false
        })
      },
      handleCurrentChange(val) {
        this.getDatas(val)
      }
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;word-break:normal;}
  #home{background-color:#F8F9FA;padding:20px;display: grid;gap: 20px;}
  .content{background-color: #ffffff;padding: 30px;display: grid;gap: 20px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);border-radius: 16px;}
  .title{color:#2D3648;font-size: 20px;font-weight: bold;display: flex;justify-content: space-between;align-items: center;}
  .title div{display: flex;align-items: center;}
  .title div *{padding:10px 16px;font-size: 14px;}
  .pager{display: flex;justify-content: center;}
  .font-size-16 {font-size: 20px;}
  .margin-top-switch {margin-top: 10px;}
  .center {display: flex;justify-content: flex-start;}
  .avatar-uploader-icon {font-size: 18px;color: #8c939d;}
  .headImageShow {width: 76px;height: 76px;border-radius: 4px;}
  @media (max-width: 768px) {
    .title{flex-direction: column;}
    .title div{margin-top:20px;}
    .center{display: flex;justify-content: center;}
    .content{padding:20px 5px;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {

  }
</style>
